import React, { useEffect, useState } from 'react';
import ReactStars from "react-rating-stars-component";
import ProgressBar from 'react-bootstrap/ProgressBar';
import './OperatProf.css'

const ModalSection = ({ scrollToReviews, operatorAllReviews, reviewAll }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [feedbackData, setFeedbackData] = useState(0);
    const [isDataLoaded, setIsDataLoaded] = useState(false);


    useEffect(() => {
        if (reviewAll?.averageRating !== undefined) { // Check if averageRating exists (even if it's 0)
            setFeedbackData(reviewAll.averageRating);
            setIsDataLoaded(true); // Mark data as loaded
        }
    }, [reviewAll]);



    const toggleTooltip = () => {
        setIsVisible(!isVisible);
    };

    const closeTooltip = () => {
        setIsVisible(false);
    };


    if (!reviewAll?.ratingDistribution) return null;

    const ratingDistribution = reviewAll.ratingDistribution;
    const totalRatings = Object.values(ratingDistribution).reduce((acc, val) => acc + val, 0);

    const getPercentage = (value) => (totalRatings ? Math.round((value / totalRatings) * 100) : 0);


    console.log(reviewAll, "reviewAll")

    return (

        <div
            style={{ position: 'relative', display: 'inline-block' }}
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
        >
            {/* Clickable Rating Text */}
            <span
                style={{ cursor: 'pointer', color: 'orange' }}
                onClick={toggleTooltip}
            >
                {console.log(feedbackData, "feedbackDatacheck")}
                {isDataLoaded && (
                    <ReactStars
                        count={5}
                        value={feedbackData}
                        size={30}
                        activeColor="#ffd438"
                        isHalf={true}
                        precision={0.1}
                        edit={false}
                        className="starsColor"
                    />
                )}
            </span>

            {/* Tooltip Content */}
            {isVisible && (
                <div
                    className="modalMainPop averageRateTextModal"
                >
                    {/* Close Button */}
                    <div
                        style={{
                            position: 'absolute',
                            top: '5px',
                            right: '5px',
                            cursor: 'pointer',
                            fontSize: '14px',
                        }}
                        onClick={closeTooltip}
                    >
                        ×
                    </div>

                    <div className='starSection'>
                        <ReactStars
                            count={5}
                            value={feedbackData}
                            size={24}
                            activeColor="#ffd438"
                            isHalf={true}
                            precision={0.1}
                            edit={false}
                            className="starsColor"
                        /> {reviewAll?.averageRating} out of 5</div>
                    <div>Based on {reviewAll?.totalReviews} reviews</div>
                    <div>
                        {['fiveStar', 'fourStar', 'threeStar', 'twoStar', 'oneStar'].map((star, index) => {
                            const starNumber = 5 - index;
                            const percentage = getPercentage(ratingDistribution[star]);
                            return (
                                <div key={star} className="starSection">
                                    {starNumber} star: <ProgressBar className="custom-progress-bar" now={percentage} /> {percentage}%
                                </div>
                            );
                        })}
                    </div>
                    <div className='custormersReviewText basedOnText' onClick={scrollToReviews}>See customer reviews {">"}</div>
                </div>
            )}
        </div>
    )
}

export default ModalSection
